export const AB_TEST_DATA_KEY = 'ab_test_data';
export const SESSION_DATA_KEY = 'ab_test_session_data';
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes - to match GA session timeout
